module.exports = __webpack_public_path__ + "media/images/app_buttons/button__googlePlay-61bb0f0cec8d30eecfaa7fd1fd299f48.svg";